import React from "react";
import PropTypes from "prop-types";
import EnhancedCard from "common/components/EnhancedCard";
import DataProvider from "common/components/DataProvider";
import OfferList from "core/OfferList";
import { Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const ResourceDashboard = ({ resource, history }) => {
  const { t } = useTranslation();
  return (
    <EnhancedCard
      title={t("offers_list.upcomming_title")}
      cardContentRoot={{ padding: 0 }}
      action={
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            history.push(`/${resource.singular}/${resource.id}/offers/new`);
          }}
        >
          {t("offers_list.create_btn")}
        </Button>
      }
    >
      <DataProvider
        url={`/${resource.plural}/${resource.id}/offers?range=upcoming`}
        error={() => (
          <Typography>{t("offers_list.no_upcoming_offer_found")}</Typography>
        )}
        render={(data) => <OfferList offers={data} resource={resource} />}
      />
    </EnhancedCard>
  );
};

ResourceDashboard.propTypes = {
  resource: PropTypes.shape({
    id: PropTypes.number.isRequired,
    singular: PropTypes.string.isRequired,
    plural: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default ResourceDashboard;
